import { api } from '@/shared/api/client';
import type {
  GetCourseRequest,
  GetCoursesResponse,
} from '../model/dto';

export const getCourses = async (params?: GetCourseRequest) => {
  const { data } = await api.get<GetCoursesResponse>('/courses/', { params });
  return data;
};
